import React, { Component } from 'react'

class ContactView extends Component {

    render() {
        let contact = this.props.contactInfo;
        if (!contact) {
            return null;
        }

        return (
            <div>
                <div>
                    <div className="form-row-item">
                        <div className="form-element">
                            <label className="form-element-label" htmlFor="#">Категория</label>
                            <div className="form-element-data date">
                                <div className="form-element-data-text">
                                    <p>{contact.contactType}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="form-row-item">
                        <div className="form-element">
                            <label className="form-element-label" htmlFor="#">Телефон</label>
                            <div className="form-element-data date">
                                <div className="form-element-data-text">
                                    <p>{contact.phone}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {contact.email && <div className="form-row-item">
                        <div className="form-element">
                            <label className="form-element-label" htmlFor="#">Почта</label>
                            <div className="form-element-data">
                                <div className="form-element-data-text">
                                    <p>{contact.email}</p>
                                </div>
                            </div>
                        </div>
                    </div>}
                </div>
                <div className="form-row">
                    <div className="form-row-item">
                        <div className="form-element">
                            <div className="form-element-data date">
                                <div className="form-element-data-text">
                                    {contact.active ? <span className="label label-success">Активен</span> :
                                        <span className="label label-gray">Неактивен</span>}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        )
    }
}

export default ContactView
